import React, { lazy, Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import PrivateRoute from './utils/PrivateRoute';
import {
  ApolloClient,
  ApolloProvider,
  InMemoryCache,
  createHttpLink,
} from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import './App.css';

const Login = lazy(() => import('./pages/user/components/Login'));
const Reset = lazy(() => import('./pages/user/components/Reset'));
const OpenBalances = lazy(() => import('./pages/openBalances/OpenBalances'));
const Letter = lazy(() => import('./pages/letter/Letter'));
const Wajebaat = lazy(() => import('./pages/wajebaat/Wajebaat'));
const Volunteer = lazy(() => import('./pages/volunteer/Volunteer'));
const Checkin = lazy(() => import('./pages/checkin/Checkin'));
const Admin = lazy(() => import('./pages/admin/Admin'));
const Review = lazy(() => import('./pages/review/Review'));
const Takhmeen = lazy(() => import('./pages/takhmeen/Takhmeen'));
const MasjidPage = lazy(() => import('./pages/masjid/Masjid'));
const Chat = lazy(() => import('./pages/chat/Chat'));

const httpLink = createHttpLink({
  uri: '/graphql',
});

const authLink = setContext((_, { headers }) => {
  const token = localStorage.getItem('id_token');
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : '',
    },
  };
});

const client = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache(),
});

function App() {
  return (
    <ApolloProvider client={client}>
      <Router>
        <Suspense fallback={<div className="pageContainer"><p>Loading...</p></div>}>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/login" element={<Login />} />
          <Route path="/reset" element={<Reset />} />
          <Route
            path="/pledges"
            element={
              <PrivateRoute>
                <OpenBalances />
              </PrivateRoute>
            }
          />
          <Route
            path="/letter"
            element={
              <PrivateRoute>
                <Letter />
              </PrivateRoute>
            }
          />
          <Route
            path="/wajebaat"
            element={
              <PrivateRoute>
                <Wajebaat />
              </PrivateRoute>
            }
          />
          <Route
            path="/volunteer"
            element={
              <PrivateRoute requiredRole="MAALIYA_VOLUNTEER">
                <Volunteer />
              </PrivateRoute>
            }
          />
          <Route
            path="/checkin"
            element={
              <PrivateRoute requiredRole="MAALIYA_VOLUNTEER">
                <Checkin />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin"
            element={
              <PrivateRoute requiredRole="LETTER_ADMIN">
                <Admin />
              </PrivateRoute>
            }
          />
          <Route
            path="/review"
            element={
              <PrivateRoute requiredRole="LETTER_ADMIN">
                <Review />
              </PrivateRoute>
            }
          />
          <Route
            path="/takhmeen"
            element={
              <PrivateRoute requiredRole="LETTER_ADMIN">
                <Takhmeen />
              </PrivateRoute>
            }
          />
          <Route
            path="/masjid"
            element={
              <PrivateRoute requiredRole="LETTER_ADMIN">
                <MasjidPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/chat"
            element={
              <PrivateRoute requiredRole="CHAT_ADMIN">
                <Chat />
              </PrivateRoute>
            }
          />
        </Routes>
        </Suspense>
      </Router>
    </ApolloProvider>
  );
}

export default App;
